import axios from 'axios';
import Globals from '../Globals';
import { getLogModel } from '../Functions';
import LoggingService from './LoggingService';

const {
    ERROR_LOG_ID,
    ERROR_CODE,
    BFF_PATH: { BASE_URL, TICKETING },
} = Globals;

class TicketingService {
    constructor() {
        this.serviceUrl = axios.create({
            baseURL: BASE_URL + TICKETING.BASE_PATH,
        });
    }

    methodName = async (body, token) => {
        const { config, data } = this.parseConfig(body, token); //get base config for request
        const response = await this.serviceUrl.post(/*methodEndpoint, data, config*/);
        return this.parseResponse(response); //parse JSONS
    };

    parseConfig = (body, token) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                ErrorCode: ERROR_CODE,
            },
        };
        const data = {
            headers: {
                Authorization: `${token}`,
                ErrorCode: ERROR_CODE,
            },
            body: JSON.stringify(body),
        };
        return { config, data };
    };

    parseResponse = response => {
        if (response?.data?.body) {
            const body = response.data.body;
            /* if (body.Result) {
        body.Result = body.Result;
      }*/
            response.data.body = JSON.parse(body);

            return response.data;
        }
        return response;
    };

    /*

 TICKETING API CALLS

  */
    createTicket = async (token, body) => {
        const { config, data } = this.parseConfig(body, token); //get base config for request

        const response = await this.serviceUrl
            .post(TICKETING.CREATE_TICKET, data, config)
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
        return this.parseResponse(response); //parse JSONS
    };

    getTickets = async (token, body) => {
        const { config, data } = this.parseConfig(body, token); //get base config for request
        const response = await this.serviceUrl
            .post(TICKETING.GET_TICKETS, data, config)
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
        return this.parseResponse(response); //parse JSONS
    };

    getSelects = async (token, body) => {
        const { config, data } = this.parseConfig(body, token); //get base config for request
        const response = await this.serviceUrl
            .post(TICKETING.GET_ALL_SELECTS, data, config)
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });

        return this.parseResponse(response); //parse JSONS
    };

    getInfoTicket = async (token, body) => {
        const { config, data } = this.parseConfig(body, token); //get base config for request
        const response = await this.serviceUrl
            .post(TICKETING.GET_INFO_TICKET, data, config)
            .catch(function (error) {
                var newError = getLogModel(
                    Globals.ERROR_LOG_ID,
                    error.config.url,
                    config,
                    data,
                    error
                );
                new LoggingService().createLog(token, newError);
            });
        return this.parseResponse(response); //parse JSONS
    };
}

//const service = new TicketingService();

export default TicketingService;
